/* Aurah — variant image swap.
   theme.js rewrites slide 1's <img> in place when a size/frame is chosen, which
   is invisible whenever the shopper is looking at any other slide. This finds
   the slide matching the selected variant's image and activates it instead. */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var gallery = document.querySelector('[data-gallery]');
  var form = document.querySelector('[data-product-form]');
  if (!gallery || !form) return;
  var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__slide'));
  if (slides.length < 2) return;

  function base(u) { return (u || '').split('?')[0].split('/').pop(); }

  var firstImg = slides[0].querySelector('img');
  var firstSrc = firstImg ? firstImg.getAttribute('src') : null;
  var firstSet = firstImg ? firstImg.getAttribute('srcset') : null;

  var product = null;
  function getProduct() {
    if (product) return Promise.resolve(product);
    var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!h) return Promise.resolve(null);
    return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { product = j; return j; })
      .catch(function () { return null; });
  }

  function hydrate(slide) {
    var img = slide.querySelector('img[data-src]');
    if (!img) return;
    var ss = img.getAttribute('data-srcset');
    if (ss) img.setAttribute('srcset', ss);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function activate(i) {
    hydrate(slides[i]);
    var thumb = document.querySelector('[data-thumb-index="' + i + '"]');
    if (thumb) { thumb.click(); return; }
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-thumb-index]'),
      function (t) { t.classList.remove('is-active'); });
    var c = document.querySelector('[data-gallery-current]');
    if (c) c.textContent = i + 1;
  }

  function selectedOptions() {
    var out = {};
    Array.prototype.forEach.call(form.querySelectorAll('input[type="radio"]:checked'), function (r) {
      var m = (r.name || '').match(/options\[(.+)\]/);
      if (m) out[m[1]] = r.value;
    });
    return out;
  }

  function sync() {
    getProduct().then(function (p) {
      if (!p || !p.variants) return;
      var sel = selectedOptions();
      var v = null;
      for (var k = 0; k < p.variants.length; k++) {
        var cand = p.variants[k], ok = true;
        for (var oi = 0; oi < (p.options || []).length; oi++) {
          var o = p.options[oi];
          var name = typeof o === 'string' ? o : o.name;
          if (sel[name] !== cand['option' + (oi + 1)]) { ok = false; break; }
        }
        if (ok) { v = cand; break; }
      }
      if (!v || !v.featured_image || !v.featured_image.src) return;
      var want = base(v.featured_image.src);
      if (firstImg && firstSrc && base(firstImg.getAttribute('src')) !== base(firstSrc)) {
        firstImg.setAttribute('src', firstSrc);
        if (firstSet) firstImg.setAttribute('srcset', firstSet);
      }
      for (var i = 0; i < slides.length; i++) {
        if (base(slides[i].getAttribute('data-slide-src')) === want) { activate(i); return; }
      }
    });
  }

  function schedule() { setTimeout(sync, 140); setTimeout(sync, 480); }

  form.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') schedule();
  });
  form.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.variant-swatch')) schedule();
  });
})();